import dayjs from '@beunity/design/lib/dayjs_extend.js';

/* Triggered on 'js-update-auto-delete-options' select change */
/* Replace/fill 'js-auto-delete-options' options based on selected option dataset */

/* Expected dataset attributes: */
/* - autoDeleteEnabled: boolean string, whether auto delete is enabled for the preset */
/* - autoDeleteOptions: JSON stringified array of [label, value, dataset] for options */
/* - autoDeleteAtFromPreset: JSON stringified date string for preset date */

$(document).on('change', '.js-update-auto-delete-options', (e) => {
  const opt = e.currentTarget?.options[e.currentTarget?.selectedIndex];
  const el = document.querySelector('.js-auto-delete-options');

  if (!opt || !el) return;

  const { autoDeleteEnabled, autoDeleteOptions, autoDeleteAtFromPreset } = opt.dataset;
  const optionsHtml = JSON.parse(autoDeleteOptions)
    .map(([label, value, dataset]) => {
      const data = dataset?.data || {};
      const dataAttrs = Object.entries(data)
        .filter(([, v]) => v != null)
        .map(([k, v]) => {
          const attrName = `data-${k.replaceAll('_', '-')}`;
          const attrValue = v;
          return `${attrName}="${attrValue}"`;
        })
        .join(' ');
      const attrs = dataAttrs.length ? ` ${dataAttrs}` : '';
      const selectedOn = (!JSON.parse(autoDeleteEnabled) && value === 'never') || (JSON.parse(autoDeleteEnabled) && value === 'preset');

      return `<option value="${value}"${attrs}${selectedOn ? ' selected' : ''}>${label}</option>`;
    })
    .join('');

  el.innerHTML = optionsHtml;
  el.dispatchEvent(new Event('change', { bubbles: true }));

  /* Auto set date value for custom date input */
  const dateInput = document.querySelector('.js-update-auto-delete-date input');

  if (autoDeleteAtFromPreset && dateInput) {
    const dateString = JSON.parse(autoDeleteAtFromPreset);
    const nativeYmd = dayjs.utc(dateString).format('YYYY-MM-DD'); // 2026-01-26
    const customDmy = dayjs.utc(dateString).format('DD/MM/YYYY'); // 26/01/2026

    dateInput.type === 'date' ? dateInput.value = nativeYmd : dateInput.value = customDmy;
  }
});
